import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PropsDetails } from './types';
import FolderActions from './FolderActions';
import Check from '../../svg/Check';
import Copy from '../../svg/Copy';

const FolderDetails = ({ FolderDetail, error, FolderStatuses, getInvestorTypeClass, actions }: PropsDetails): JSX.Element => {
  const { t } = useTranslation();
  const [isCopied, setIsCopied] = useState(false);

  const date = new Date(FolderDetail.creation_date);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const formattedDate = `${day}/${month}/${year}`;

  const handleCopyId = () => {
    navigator.clipboard.writeText(FolderDetail.id);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <>
      {/* ID */}
      <td className="cell-id">
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span title={FolderDetail.id} style={{ fontFamily: 'monospace' }}>
            {FolderDetail.id.substring(0, 5)}..
          </span>
          <button
            type="button"
            onClick={handleCopyId}
            title={t('common.copy')}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '2px',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            {isCopied ? <Check /> : <Copy />}
          </button>
        </div>
      </td>

      {/* Date */}
      <td>{formattedDate || '-'}</td>

      {/* Investisseur */}
      <td>
        <span className="investor-name">{FolderDetail.client?.last_name ?? FolderDetail.present} {FolderDetail.client?.first_name}</span>
        {FolderDetail.is_physical !== null ?
          <>
            <span className={`investor-type ${getInvestorTypeClass(FolderDetail.is_physical)}`}>
              {FolderDetail.is_physical ? t('investor-type.pp') : t('investor-type.pm')}
            </span>
          </>
          :
          ""}
          <span className="u-txt-size-xs partner-sub">({FolderStatuses})</span>
      </td>

      {/* SCPI */}
      <td>{FolderDetail?.product_name || '-'}</td>


      {FolderDetail.manager ?
        <>
          {/* Partenaires */}
          <td>
            {FolderDetail.manager?.name} {FolderDetail.manager?.firstname}
            {FolderDetail.manager?.external_id && <span className="u-txt-size-xs partner-sub"> ({FolderDetail.manager?.external_id})</span>}
          </td>
          {/* Conseiller */}
          <td>
            {FolderDetail.advisor?.name} {FolderDetail.advisor?.firstname}
            {FolderDetail.advisor?.external_id && <span className="u-txt-size-xs partner-sub"> ({FolderDetail.advisor?.external_id})</span>}
          </td>
        </>
        :
        <>
          {/* Partenaires */}
          <td>
            {FolderDetail.advisor?.name} {FolderDetail.advisor?.firstname}
            {FolderDetail.advisor?.external_id && <span className="u-txt-size-xs partner-sub"> ({FolderDetail.advisor?.external_id})</span>}
          </td>
          {/* Conseiller */}
          <td></td>
        </>
      }

      {/* Nature */}
      <td>
        {FolderDetail.nature ? <span className={`nature-tag nature-tag-${FolderDetail.nature.toLowerCase() ?? ''}`}  title={t(`nature.${FolderDetail.nature.toLowerCase()}`)}>{FolderDetail.nature ?? '-'}</span> : ""}
      </td>

      {/* Parts */}
      <td style={{ textAlign: 'center' }}>{FolderDetail.nb_parts}</td>

      {/* Actions */}
      <td style={{ textAlign: 'center' }}>
        <FolderActions FolderDetail={FolderDetail} {...actions} />
      </td>
    </>
  );
}

export default FolderDetails;
